import { render } from "./BarcodeDemo.vue?vue&type=template&id=fedffb8a&scoped=true"
import script from "./BarcodeDemo.vue?vue&type=script&lang=js"
export * from "./BarcodeDemo.vue?vue&type=script&lang=js"

import "./BarcodeDemo.vue?vue&type=style&index=0&id=fedffb8a&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fedffb8a"]])

export default __exports__